import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';
import { sumOfItemPrice } from '../ga4utils';

export const trackAddToCart = ({
  location,
  currency,
  addedItems,
  message = undefined,
}: {
  location: string;
  currency: string;
  addedItems: EcommerceCartItem | Array<EcommerceCartItem> | undefined;
  message?: string;
}) => {
  const normalizedItems = Array.isArray(addedItems) ? addedItems : addedItems ? [addedItems] : [];

  const {
    item_list_name: itemListName,
    item_list_slot: itemListSlot,
    item_list_service_config: itemListServiceConfig,
  } = normalizedItems[0] || {};

  const value = sumOfItemPrice(addedItems);
  const payload = {
    event: 'add_to_cart',
    location,
    value,
    message: message,
    ...(itemListName && { item_list_name: itemListName }),
    ...(itemListSlot && { item_list_slot: itemListSlot }),
    item_list_service_config: itemListServiceConfig,
    ecommerce: {
      currency,
      items: normalizedItems,
    },
  };

  pushToDataLayer(payload);
};
